import React, { Component } from 'react';
import { connect } from 'react-redux';
import LeaseForm from 'components/LeaseForm';
import { getSubmitStatus } from 'reducers';
import { findLease, updateLease } from 'actions/leases';
import { initialize } from 'redux-form';

class UpdateLease extends Component {
  componentDidMount() {
    this.fetchLeaseInfo();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.leaseId !== this.props.leaseId) {
      this.fetchleaseInfo();
    }
  }

  fetchLeaseInfo() {
    const { findLease, leaseId } = this.props;
    findLease(leaseId);
  }

  render() {
    const { updateLease, SubNav, lease, leaseId, ...props } = this.props;
    if (!lease) {
      return <div>Loading</div>;
    }

    return (
      <div>
        <h1>Update Lease</h1>
        <br />
        <SubNav />
        <LeaseForm
          initialValues={{
            att_subscription: lease.att_subscription,
            description: lease.description || '',
            linked_user_profile: lease.user_profile_linked
              ? lease.user_profile
              : null,
            imei: lease.imei || '',
          }}
          onSubmit={(values) => updateLease(leaseId, values)}
          {...props}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'lease'),
});

const mapDispatchToProps = {
  updateLease,
  findLease,
  initialize,
};

UpdateLease = connect(mapStateToProps, mapDispatchToProps)(UpdateLease);

export default UpdateLease;
